export default {
  tabs: {
    online_shop: 'Online Shop',
    reservations: 'Reserveringen',
    storefront: 'Storefront',
  },
};
